// extracted by mini-css-extract-plugin
export default {"combo_group_card":"ComboPackageGroupContainer_combo_group_card__e1Iv7"};